module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"FREE":"Kostenlos"},"en":{"FREE":"Free"}}')
  delete Component.options._Ctor
}
